<template>
    <div class="row">
        <div class="col-2">
            <h6><i class="fas fa-project-diagram"></i> <fa-icon icon="running" /> Verbs</h6>
            <div><a href="javascript:;" @click="showCreateVerb=!showCreateVerb"><fa-icon icon="plus-square" /></a></div>
            <div v-if="showCreateVerb" class="row no-gutters">
                <div class="col-10">
                    <input class="form-control form-control-sm" type="text" placeholder="Verb" v-model="verb" @input="err001=''" @keyup.enter="newVerb()" />
                    <span v-if="err001" class="badge text-danger">{{ err001 }}</span>
                </div>
                <div class="col-2">
                    <a href="javascript:;" class="btn btn-sm text-danger" @click="showCreateVerb=!showCreateVerb"><fa-icon icon="ban" /></a>
                </div>
            </div>
            <div class="row no-gutters" v-for="(verb, idx) in verbs" :key="idx">
                <div class="col">
                    <small :class="{del:usedVocabularies.indexOf(verb)!==-1, bold:usedVocabularies.indexOf(verb)===-1}">{{ verb }}</small>
                    <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                            <a href="javascript:;" @click="addNode(verb, 'action')"><fa-icon icon="comment" /></a>
                        </li>
                        <li class="list-inline-item">
                            <a href="javascript:;" @click="addNode(verb, 'activity')"><fa-icon icon="comment-alt" /></a>
                        </li>
                        <li class="list-inline-item">
                            <a href="javascript:;" class="text-danger" @click="removeVerb(idx)"><fa-icon icon="trash" /></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div>{{ functionsFinishedRate }} <fa-icon icon="percentage" /></div>
            <div class="row">
                <div class="col mt-3">
                    <button class="btn btn-secondary btn-sm" @click="loadAllActors()"><fa-icon icon="users" /> Load All Actors</button>
                </div>
            </div>
        </div>

        <div class="col-8">
            <!-- Diagram Buttons -->
            <div class="row">
                <ul class="list-inline mb-0 mt-1">
                    <li v-if="!isGenerated" class="list-inline-item">
                        <a href="javascript:;" @click="generateImage()"><fa-icon icon="image" /> Generate Image</a>
                    </li>
                    <li v-else class="list-inline-item">
                        <a href="javascript:;" @click="isGenerated=false"><fa-icon icon="undo" /></a>&nbsp;
                        <file-download :isPng="true" title="Download Diagram" :data="imageData" :downloadName="downloadFilename" />
                    </li>
                    <li v-if="isChanged" class="list-inline-item">
                        <a href="javascript:;" @click="saveDiagram()"><fa-icon icon="save" /> Save Diagram</a>
                    </li>
                </ul>
            </div>
            <div class="row">
                <div id="dynamic-diagram" ref="dynamicDiagram" class="col"></div>
            </div>
        </div>

        <div class="col-2 pt-4">
            <div id="dynamic-diagram-overview" class="mb-3"></div>
            <div v-if="tmpSelectionData.isLink===false && (tmpSelectionData.data.category === 'action' || tmpSelectionData.data.category === 'activity')" class="row">
                <div class="col">
                    <button class="btn btn-warning btn-sm" @click="convertOrUpdateToTask()">Convert/Update to Task</button>
                </div>
            </div>
            <div v-if="tmpSelectionData.isLink===false">
                <div v-if="selectedItem.data.category === 'action' || selectedItem.data.category === 'activity'" class="row">
                    <label for="mark-as-done" class="col-8 col-form-label">Mark as done</label>
                    <div class="col-4">
                        <input type="checkbox" id="mark-as-done" class="form-control" :checked="tmpSelectionData.data.isDone" @change="onChangeIsDone($event.target.checked)"/>
                    </div>
                </div>
                <div class="input-group input-group-sm mb-3">
                    <div class="input-group-prepend">
                        <div class="input-group-text">Title: </div>
                    </div>
                    <input type="text" class="form-control" :value="tmpSelectionData.data.key" @input="onChangeKey($event.target.value)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import slug from 'slug';
    import * as go from 'gojs';
    import { mapState } from 'vuex';
    import { DynamicDiagramRoleNode, DynamicDiagramActionNode, DynamicDiagramActivityNode, DynamicDiagramStartNode, DynamicDiagramEndNode, DynamicDiagramLink, TmpDynamicDiagramLink } from '../gotpls';
    import { DIAGRAM_SET,VOCABULARY_SET_USED,VOCABULARY_VERB_REMOVE,VOCABULARY_VERB_ADD,TASK_SET } from '../mutation-types';
    import FileDownload from '@/components/FileDownload';

    const $ = go.GraphObject.make;
    const nextCategory = {actor: 'action', action: 'start', start: 'activity', activity: 'activity'};
    const nextTitle = {start:'start', end:'end', actor:'New Actor', action:'New Action', activity: 'New Activity'};

    export default {
        name: "DynamicDiagram",

        computed: {
            ...mapState(['project', 'verbs', 'diagrams', 'used']),
            usedVocabularies() {
                return this.used.map(v => v.v);
            },
            downloadFilename() {
                return slug(this.project.name, {mode: 'rfc3986'}) + '_dynamic.png';
            },
            newNode: function () {
                return function (key, category, parent = '') {
                    key === null && (key = nextTitle[category]);
                    return {key, category, parent, isDone: false};
                };
            },
            selectedItem() {
                return this.diagram.selection.first();
            },
            functionsFinishedRate() {
                return this.finishedRate;
            }
        },

        data() {
            return {
                err001: null,
                showCreateVerb: false,
                verb: '',
                finishedRate: 0,

                imageData: '',
                isGenerated: false,
                isChanged: false,

                diagram: {},

                tmpSelectionData: {},
            }
        },

        mounted() {
            this.diagram = $(go.Diagram, this.$refs.dynamicDiagram, {
                layout: $(go.TreeLayout),
                'commandHandler.deletesTree': true,
                'undoManager.isEnabled': true,
                'ChangedSelection': e => {
                    this.onChangedSelection(e);
                },
            });

            let nodeTpls = new go.Map();
            nodeTpls.add('actor', DynamicDiagramRoleNode);
            nodeTpls.add('action', DynamicDiagramActionNode);
            nodeTpls.add('start', DynamicDiagramStartNode);
            nodeTpls.add('activity', DynamicDiagramActivityNode);
            nodeTpls.add('end', DynamicDiagramEndNode);
            this.diagram.nodeTemplateMap = nodeTpls;
            this.diagram.linkTemplate = DynamicDiagramLink;

            this.diagram.contextMenu = $('ContextMenu',
                $('ContextMenuButton', $(go.TextBlock, {margin: new go.Margin(6, 10, 6, 10), font: 'bold .8rem "Nunito",sans-serif'}, 'New Actor'), {click: this.onContextMenuButtonClick('New Actor', 'actor')}),
                $('ContextMenuButton', $(go.TextBlock, {margin: new go.Margin(6, 10, 6, 10), font: 'bold .8rem "Nunito",sans-serif'}, 'New Action'), {click: this.onContextMenuButtonClick('New Action', 'action')}),
                $('ContextMenuButton', $(go.TextBlock, {margin: new go.Margin(6, 10, 6, 10), font: 'bold .8rem "Nunito",sans-serif'}, 'Start Point'), {click: this.onContextMenuButtonClick('start', 'start')}),
                $('ContextMenuButton', $(go.TextBlock, {margin: new go.Margin(6, 10, 6, 10), font: 'bold .8rem "Nunito",sans-serif'}, 'New Activity'), {click: this.onContextMenuButtonClick('New Activity', 'activity')}),
                $('ContextMenuButton', $(go.TextBlock, {margin: new go.Margin(6, 10, 6, 10), font: 'bold .8rem "Nunito",sans-serif'}, 'End Point'), {click: this.onContextMenuButtonClick('end', 'end')}),
            );
            this.diagram.toolManager.linkingTool.temporaryLink = TmpDynamicDiagramLink;

            this.diagram.commandHandler.doKeyDown = () => {
                const e = this.diagram.lastInput;
                if (e.key.charCodeAt(0) === 9 && this.selectedItem instanceof go.Node) {
                    if (typeof nextCategory[this.selectedItem.data.category] !== 'undefined') {
                        this.diagram.model.commit(m => {
                            const data = this.newNode(null, nextCategory[this.selectedItem.data.category], this.selectedItem.data.key);
                            m.addNodeData(data);
                            const node = this.diagram.findNodeForData(data);
                            this.diagram.select(node);
                        }, 'new item');
                        return;
                    }
                }
                go.CommandHandler.prototype.doKeyDown.call(this.diagram.commandHandler);
            };

            if (this.diagrams.dynamic) {
                this.diagram.model = go.Model.fromJson(this.diagrams.dynamic);
            } else {
                this.diagram.model = $(go.TreeModel, {nodeDataArray: [], linkDataArray: []});
            }
            const overview = $(go.Overview, 'dynamic-diagram-overview', {observed: this.diagram, contentAlignment: go.Spot.Center});
            overview.box.elt(0).stroke = $(go.Brush, go.Brush.Solid, {color: 'red'});
            this.caculateFinishedRate();
            this.diagram.addModelChangedListener(evt => {
                this.isChanged = true;
                if (evt.isTransactionFinished) {
                    this.caculateFinishedRate();
                    this.saveModel(evt.model);
                }
            });
        },

        methods: {
            async newVerb() {
                let vocabulary = await this.$db.vocabularies.get({pid: this.project.id});
                if (vocabulary) {
                    if (vocabulary.verbs.indexOf(this.verb) === -1) {
                        vocabulary.verbs.push(this.verb);
                        await this.$db.vocabularies.update(vocabulary.id, {verbs: vocabulary.verbs});
                    }
                } else {
                    vocabulary = {pid: this.project.id, nouns:[], verbs:[this.verb], used:[]};
                    await this.$db.vocabularies.add(vocabulary);
                }
                this.$store.commit(VOCABULARY_VERB_ADD, this.verb);
            },

            async removeVerb(idx) {
                const verb = this.verbs[idx];
                let vocabulary = await this.$db.vocabularies.get({pid: this.project.id});
                let i;
                if ((i = vocabulary.verbs.indexOf(verb)) !== -1) {
                    vocabulary.verbs.splice(i, 1);
                    await this.$db.vocabularies.update(vocabulary.id, {verbs: vocabulary.verbs});
                }
                this.$store.commit(VOCABULARY_VERB_REMOVE, idx);
            },

            caculateFinishedRate() {
                const total = this.diagram.model.nodeDataArray.reduce((i, v) => {
                    return v.category === 'action' || v.category === 'activity' ? ++i : i;
                }, 0);
                if (total === 0) return 0;
                const n = this.diagram.model.nodeDataArray.reduce((i, v) => {
                    return (v.category === 'action' || v.category === 'activity') && v.isDone ? ++i : i;
                }, 0);
                this.finishedRate = (n / total * 100).toFixed(0);
            },

            loadAllActors() {
                this.used.map(v => {
                    if (v.t === 'actor') {
                        const data = this.newNode(v.v, 'actor');
                        this.diagram.model.addNodeData(data);
                    }
                });
            },

            onContextMenuButtonClick(key, category) {
                return e => {
                    e.diagram.commit(d => {
                        const data = this.newNode(key, category);
                        d.model.addNodeData(data);
                        const part = d.findPartForData(data);
                        part.location = d.toolManager.contextMenuTool.mouseDownPoint;
                    });
                }
            },

            generateImage() {
                this.imageData = this.diagram.makeImageData({scale: 1});
                this.isGenerated = true;
            },

            async addNode(verb, category) {
                // also add task
                const id = await this.$store.dispatch('addTask', {db: this.$db, from: 'dynamic', task: verb});

                let data = this.newNode(verb, category);
                data.taskId = id;
                this.diagram.model.addNodeData(data);

                if (this.usedVocabularies.indexOf(verb) === -1) { // not found, add to `used`
                    let vocabulary = await this.$db.vocabularies.get({pid: this.project.id});
                    if (vocabulary) {
                        typeof vocabulary.used !== 'undefined' ?
                            vocabulary.used.push({v:verb,t:category}) :
                            (vocabulary.used = [{v:verb,t:category}])
                        ;
                        await this.$db.vocabularies.update(vocabulary.id, {used: vocabulary.used});
                    }
                    this.$store.commit(VOCABULARY_SET_USED, {v:verb,t:category});
                }
            },

            saveModel(model) {
                // TODO: link
                const json = model.toJson('TreeModel') //.replace(',\n  "linkDataArray": []', '');
                this.$store.commit(DIAGRAM_SET, {isStatic: false, data: json});
            },

            async saveDiagram() {
                let diagram = await this.$db.diagrams.get({pid: this.project.id});
                if (typeof diagram === 'undefined') {
                    await this.$db.diagrams.add({pid: this.project.id, static: '{"class":"GraphLinksModel","nodeDataArray":[],"linkDataArray":[]}', dynamic: this.diagrams.dynamic});
                } else {
                    await this.$db.diagrams.update(diagram.id, {dynamic: this.diagrams.dynamic});
                }
                this.isChanged = false;
            },

            async convertOrUpdateToTask() {
                if (typeof this.selectedItem.data.taskId === 'undefined') {
                    // add to task
                    const id = await this.$store.dispatch('addTask', {db: this.$db, from: 'dynamic', task: this.selectedItem.data.key});
                    this.diagram.model.commit(m => {
                        m.set(this.selectedItem.data, 'taskId', id);
                    }, 'set task id');
                } else {
                    // update task
                    await this.$db.tasks.update(this.selectedItem.data.taskId, {task: this.selectedItem.data.key, isDone: this.selectedItem.data.isDone});
                    this.$store.commit(TASK_SET, {id: this.selectedItem.data.taskId, task: this.selectedItem.data.key, isDone: this.selectedItem.data.isDone});
                }
            },

            onChangeIsDone(v) {
                this.tmpSelectionData.data.isDone = v;
                if (this.selectedItem instanceof go.Node) {
                    this.diagram.model.commit(m => {
                        m.set(this.selectedItem.data, 'isDone', v);
                    }, 'toggle done');
                }
            },

            onChangeKey(v) {
                this.tmpSelectionData.data.key = v;
                if (this.selectedItem instanceof go.Node) {
                    this.diagram.model.commit(m => {
                        m.set(this.selectedItem.data, 'key', v);
                    }, 'change key');
                }
            },

            onChangedSelection(e) {
                if (this.selectedItem instanceof go.Node) {
                    // this.diagram.centerRect(this.selectedItem.actualBounds);
                    return this.tmpSelectionData = {isLink: false, data: {...this.selectedItem.data}};
                } else if (this.selectedItem instanceof go.Link) {
                    return this.tmpSelectionData = {isLink: true, data: {...this.selectedItem.data}};
                }
                this.tmpSelectionData = {};
            },

        },

        components: {
            FileDownload
        }
    }
</script>

<style scoped>
    #dynamic-diagram {
        background-color: var(--white);
        min-height: 30rem;
    }

    #dynamic-diagram-overview {
        height: 6rem;
        background-color: white;
        border: thin solid var(--primary);
    }

    .del {
        text-decoration: line-through;
    }

    .bold {
        font-weight: bold;
    }
</style>
